import styled from 'styled-components';

import { Grid2 as Grid } from '@mui/material';
import { Box } from '@mui/system';

export const ModalBox = styled(Box)`
  width: 90%;
  max-width: 1200px;
  max-height: 90vh;
  margin: auto;
  margin-top: 5vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: ${({ theme }) => theme.palette.background.paper};
  box-shadow: ${({ theme }) => theme.shadows[5]};
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.background.default};
  padding: 10px 16px;
  color: ${({ theme }) => theme.palette.text.primary};
  flex-shrink: 0;
`;

export const ModalContent = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  padding: 24px 30px;
  min-height: 0;
`;

export const ModalActionButtons = styled(Grid)`
  padding: 16px 24px;
  flex-shrink: 0;
`;
